module.exports = __webpack_public_path__ + "img/rat.d200490f.svg";